import React from 'react';
import { CloseOutlined } from '@ant-design/icons';
import { StyledReadonlyFormItem, StyledWrapper } from './styles';

type Props = {
    disabled: boolean;
    label?: string;
    value?: string;
    style?: React.CSSProperties;
    onReset?: () => void;
};

const ReadonlyFormItem: React.FC<Props> = ({ label, value = '', disabled, style, onReset }) => {
    if (label) {
        return (
            <StyledWrapper>
                <span>{label}</span>
                <StyledReadonlyFormItem style={style}>
                    <span>{value}</span>
                    {onReset && !disabled && <CloseOutlined onClick={onReset} />}
                </StyledReadonlyFormItem>
            </StyledWrapper>
        );
    }

    return (
        <StyledReadonlyFormItem style={style}>
            <span>{value}</span>
            {onReset && !disabled && <CloseOutlined onClick={onReset} />}
        </StyledReadonlyFormItem>
    );
};

export default ReadonlyFormItem;
